<template>
  <nav class="sc-tabs">
    <li
      class="sc-tab"
      v-for="(tab, index) in tabs"
      :key="index"
      v-show="tab.isShow"
      :class="{ active: currentTab.name === tab.name, error: errorTabs[index] }"
      @click="changeTab(tab)"
    >
      {{ tab.name }}
    </li>
  </nav>
</template>

<script>
export default {
  props: ["activeTab", "errorTabs"],
  data() {
    return {};
  },
  computed: {
    currentTab() {
      return this.activeTab || this.tabs[0];
    },
    tabs() {
      const tabs = [
        { name: "เนื้อหาข่าว", isShow: true },
        { name: "รายละเอียดกิจกรรม", isShow: true },
        { name: "ส่งถึงใคร", isShow: true }
      ];

      if (this.$route.params.articleType === "news") {
        // return [tabs[0], tabs[2]];
        tabs[1].isShow = false;
      }
      return tabs;
    }
  },
  methods: {
    changeTab(to) {
      this.$parent.$emit("change:article-tab", to);
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/admin/view/article/create/ContentTabs.vue